import listViewStore from '../store/Store';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';

export default function isFolderPaused(folderId: string): boolean {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (8,5): Type 'string | boolean' is not assignable to type 'boolean'.
    // @ts-expect-error
    return listViewStore.inboxPausedDateTime && folderId && folderIdToName(folderId) === 'inbox';
}
